import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Papa from "papaparse";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import ReusableModal from "../../AppPAges/ManageSettings/ReusableModal";

const ChequeForm = () => {
  const { Post } = useApi();
  const [macAddress, setMacAddress] = useState(null);
  const [activeModal, setActiveModal] = useState(false);
  const [licencekey, setLicenceKey] = useState("");
  const [isLicenseValid, setIsLicenseValid] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [bulkData, setBulkData] = useState([]);
  const [csvError, setCsvError] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    amount: "",
    date: "",
    chequeNumber: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    amount: "",
    date: "",
    chequeNumber: "",
  });

  const getFingerprintData = async () => {
    const fingerprint = await FingerprintJS.load();
    const result = await fingerprint.get();
    const uniqueId = `${result.visitorId}${user.user_id}`;

    setMacAddress(uniqueId);
  };

  const handleCSVUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      complete: (results) => {
        const { data } = results;
        if (data.length === 0) {
          setCsvError("CSV file is empty");
          return;
        }

        // Validate CSV structure
        const requiredHeaders = ["name", "amount", "cheque_no"];
        const headers = data[0].map((header) => header.toLowerCase());
        const missingHeaders = requiredHeaders.filter(
          (header) => !headers.includes(header)
        );

        if (missingHeaders.length > 0) {
          setCsvError(`Missing required columns: ${missingHeaders.join(", ")}`);
          return;
        }

        // Transform CSV data to match your format
        const processedData = data.slice(1).map((row) => {
          const rowData = {};
          headers.forEach((header, index) => {
            rowData[header] = row[index];
          });
          return {
            name: rowData.name,
            amount: rowData.amount,
            chequeNumber: rowData.cheque_no,
            date: rowData.date, // Current date as default
          };
        });

        setBulkData(processedData);
        setCsvError("");
        // navigate("/cheque-preview", {
        //   state: {
        //     bulkData,
        //     isBulkUpload: true
        //   }
        // });
      },
      error: (error) => {
        setCsvError(`Error parsing CSV: ${error.message}`);
      },
    });
  };

  const handleDirectPreview = () => {
    if (bulkData.length > 0) {
      navigate("/cheque-preview", {
        state: {
          bulkData,
          isBulkUpload: true,
        },
      });
    } else {
      setCsvError("Please upload a CSV file first");
    }
  };

  const chequeLicence = async (key) => {
    try {
      const postData = {
        device_id: macAddress,
        licence_key: key,
      };
      
      const postResponse = await Post("checkLicence", postData);

      // Check for success - try multiple possible success indicators
      if (postResponse && (
        postResponse.success === true || 
        postResponse.status === 200 || 
        postResponse.status === 201 ||
        postResponse.message === "success" ||
        postResponse.message === "License validated successfully"
      )) {
        toast.success("License validated successfully!");
        setIsLicenseValid(true);
        setActiveModal(false);
        return; // Exit early on success

      } else if (postResponse?.message === "User and device_id do not match") {
        console.error("The device ID does not match with the registered user.");
        toast.error("Device ID does not match with the registered user. Please check your device.");
        setIsLicenseValid(false);
        setActiveModal(true);

      } else if (postResponse?.message === "invalid key") {
        console.error("The provided licence key is invalid.");
        toast.error("The licence key is invalid. Please enter a valid key, or Contact PaisaVara");
        setIsLicenseValid(false);
        setActiveModal(true);
      } else {
        toast.error("License validation failed. Please try again.");
        setIsLicenseValid(false);
        setActiveModal(true);
      }
    } catch (error) {
      console.error("API Call - checkLicence - Error:", error);
      console.error("API Call - checkLicence - Error Response Status:", error?.response?.status);
      console.error("API Call - checkLicence - Error Response Data:", error?.response?.data);
      console.error("API Call - checkLicence - Error Message:", error?.response?.data?.message);
      
      setIsLicenseValid(false);
      if (
        error?.response?.status === 404 &&
        error?.response?.data?.message === "User and device_id do not match"
      ) {
        toast.error("Device ID does not match with the registered user. Please check your device.");
        setActiveModal(true);
      } else if (
        error?.response?.status === 400 &&
        error?.response?.data?.message === "invalid key"
      ) {
        toast.error("The licence key is invalid. Please enter a valid key, or Contact PaisaVara");
        setActiveModal(true);
      } else {
        toast.error("License validation failed. Please try again.");
        console.error("Error during POST request:", error);
      }
    }
  };

  const recheckPost = async () => {
    try {
      const postData = { device_id: macAddress };
      const postResponse = await Post("checkLicence", postData);
      // Check for a successful status code (200 or 201)
      if (
        postResponse &&
        (postResponse.status === 200 || postResponse.status === 201)
      ) {
        setIsLicenseValid(true);
        setActiveModal(false);
      } else {
        setIsLicenseValid(false);
        setActiveModal(true);
      }
    } catch (error) {
      setIsLicenseValid(false);
      setActiveModal(true);
      console.error("Error during recheck POST:", error);
    }
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === "amount") {
      // Allow only numbers and a single decimal, no negative values
      value = value.replace(/[^0-9.]/g, "");
      if ((value.match(/\./g) || []).length > 1) {
        value = value.substring(0, value.length - 1);
      }
      // Prevent negative values
      if (parseFloat(value) < 0) {
        value = "";
      }
    }
    if (name === "chequeNumber") {
      // Allow only alphanumeric characters, no special characters
      value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (value.length > 20) {
        value = value.substring(0, 20);
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setFormData((prevState) => ({
      ...prevState,
      date: today,
    }));
    getFingerprintData();
  }, []);

  useEffect(() => {
    if (macAddress) {
      recheckPost();
    }
  }, [macAddress]);

  // Add developer tools check
  useEffect(() => {
    const checkDevTools = () => {
      const devtools = /./;
      devtools.toString = function() {
        setActiveModal(true);
        return '';
      }

    };
    checkDevTools();
  }, []);

  const handleCloseUserModal = () => setActiveModal(false);

  // --- LicenseModal Subcomponent ---
  const LicenseModal = ({
    show,
    onClose,
    onSubmit,
    onBypass,
    loading,
  }) => {
    const [licenceKey, setLicenceKey] = useState("");
    const [error, setError] = useState("");
    const [touched, setTouched] = useState(false);

    // Validation rules
    const validate = (value) => {
      if (!value) return "License key is required.";
      if (value.length < 8) return "Minimum 8 characters required.";
      if (value.length > 30) return "Maximum 30 characters allowed.";
      if (!/^[a-zA-Z0-9_-]+$/.test(value)) return "Only letters, numbers, dash, and underscore allowed.";
      return "";
    };

    useEffect(() => {
      if (touched) setError(validate(licenceKey));
       
    }, [licenceKey, touched]);

    const handleInput = (e) => {
      setLicenceKey(e.target.value);
      setTouched(true);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      setTouched(true);
      const err = validate(licenceKey);
      setError(err);
      if (!err && !loading) onSubmit(licenceKey);
    };

    return (
      <ReusableModal
        title="Enter License Key"
        show={show}
        handleClose={onClose}
        width="420px"
      >
        <form onSubmit={handleSubmit} autoComplete="off">
          <div style={{ padding: 24, display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ marginBottom: 8, textAlign: "center", color: "#444", fontSize: 15 }}>
              Please enter your PaisaVara license key to unlock cheque printing features.<br/>
              Contact support if you need a key.
            </div>
            <div style={{ width: "100%", position: "relative", marginBottom: 18 }}>
              <input
                id="licenceKey"
                type="text"
                value={licenceKey}
                onChange={handleInput}
                onBlur={() => setTouched(true)}
                maxLength={30}
                minLength={8}
                autoFocus
                aria-label="License Key"
                style={{
                  width: "100%",
                  padding: "18px 12px 6px 12px",
                  fontSize: 16,
                  border: error ? "1.5px solid #e74c3c" : "1.5px solid #bbb",
                  borderRadius: 8,
                  outline: "none",
                  background: "#fafbfc",
                  transition: "border 0.2s",
                  boxSizing: "border-box",
                }}
              />
              <label
                htmlFor="licenceKey"
                style={{
                  position: "absolute",
                  left: 14,
                  top: licenceKey ? 4 : 20,
                  fontSize: licenceKey ? 12 : 16,
                  color: error ? "#e74c3c" : licenceKey ? "#222" : "#888",
                  background: "#fafbfc",
                  padding: "0 4px",
                  pointerEvents: "none",
                  transition: "all 0.2s",
                }}
              >
                License Key
              </label>
              <div style={{ position: "absolute", right: 12, top: 6, fontSize: 12, color: "#888" }}>
                {licenceKey.length}/30
              </div>
            </div>
            {error && (
              <div style={{ color: "#e74c3c", fontSize: 13, marginBottom: 10, width: "100%", textAlign: "left" }}>{error}</div>
            )}
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginTop: 10 }}>
              <button
                type="button"
                onClick={onBypass}
                style={{
                  padding: "8px 18px",
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#fff",
                  background: "#28a745",
                  border: "none",
                  borderRadius: 24,
                  cursor: "pointer",
                  marginRight: 8,
                  boxShadow: "0 1px 4px rgba(40,167,69,0.08)",
                  transition: "background 0.2s",
                }}
              >
                Use Without License
              </button>
              <button
                type="submit"
                disabled={!!error || !licenceKey || loading}
                style={{
                  padding: "8px 18px",
                  fontSize: 15,
                  fontWeight: 600,
                  color: loading ? "#fff" : "#f4ffee",
                  background: loading ? "#888" : "#4a5546",
                  border: "none",
                  borderRadius: 24,
                  cursor: !!error || !licenceKey || loading ? "not-allowed" : "pointer",
                  opacity: !!error || !licenceKey || loading ? 0.7 : 1,
                  boxShadow: "0 1px 4px rgba(74,85,70,0.08)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: 90,
                }}
              >
                {loading ? (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 6, width: 16, height: 16, borderWidth: 2 }}></span>
                    Submitting...
                  </span>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </form>
      </ReusableModal>
    );
  };
  // --- End LicenseModal ---

  // Move modalLoading and handlers to top level
  const [modalLoading, setModalLoading] = useState(false);
  const handleModalSubmit = async (key) => {
    setModalLoading(true);
    setLicenceKey(key);
    await chequeLicence(key);
    setModalLoading(false);
  };
  const handleBypass = () => {
    setIsLicenseValid(true);
    setActiveModal(false);
  };

  // Restore handleSave for the main cheque form
  const handleSave = () => {
    let valid = true;
    let newErrors = { ...errors };

    if (bulkData.length > 0) {
      navigate("/cheque-preview", {
        state: {
          bulkData,
          isBulkUpload: true,
        },
      });
      return;
    }
    for (let key in formData) {
      if (!formData[key]) {
        valid = false;
        newErrors[key] = "This field is required.";
      }
    }

    // Additional validation for amount
    if (formData.amount && (isNaN(formData.amount) || parseFloat(formData.amount) <= 0)) {
      valid = false;
      newErrors.amount = "Please enter a valid positive amount.";
    }

    // Additional validation for cheque number
    if (formData.chequeNumber && !/^[a-zA-Z0-9]+$/.test(formData.chequeNumber)) {
      valid = false;
      newErrors.chequeNumber = "Cheque number can only contain letters and numbers.";
    }

    setErrors(newErrors);

    if (valid) {
      navigate("/cheque-preview", { state: formData });
    }
  };

  // if (!isLicenseValid) {
  //   return (
  //     <div className="responsive-box">
  //       <div className="text-center">
  //         <h2 className="text-xl font-semibold mb-3" style={{  fontWeight: 700 }}>
  //           License Validation Required
  //         </h2>
  //         <div style={{ color: '#444', fontSize: 15, marginBottom: 18 }}>
  //           You must validate your PaisaVara license key to use cheque printing features.<br/>
  //           If you do not have a key, contact support or use the feature in demo mode.
  //         </div>
  //         <button
  //           className="btn btn-primary"
  //           onClick={() => setActiveModal(true)}
  //           style={{ color: "#fff", background: "#4a5546", borderRadius: 24, fontWeight: 600, fontSize: 16, padding: "8px 24px", marginBottom: 10 }}
  //         >
  //           Enter License Key
  //         </button>
  //       </div>
  //     {/* <LicenseModal
  //         show={activeModal}
  //         onClose={handleCloseUserModal}
  //         onSubmit={handleModalSubmit}
  //         onBypass={handleBypass}
  //         loading={modalLoading}
  //       /> */}
       
  //     </div>
  //   );
  // }

  const infoIconStyle = {
    display: "inline-block",
    marginRight: "10px",
    position: "relative",
    cursor: "pointer",
    fontSize: "20px",
    color: "#4a5546"
  };
  const tooltipStyle = {
    position: "absolute",
    left: "50%",
    top: "30px",
    transform: "translateX(-50%)",
    background: "#fff",
    color: "#222",
    border: "1px solid #e1e5e9",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    padding: "14px 18px 10px 18px",
    zIndex: 100,
    minWidth: "260px",
    maxWidth: "320px",
    width: "max-content",
    maxWidth: "90vw",
    textAlign: "center",
    fontSize: "14px",
    
    pointerEvents: "none",
    wordBreak: "break-word",
    whiteSpace: "normal",
    boxSizing: "border-box"
  };
  const arrowStyle = {
    position: "absolute",
    left: "50%",
    top: "-8px",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: "8px solid #fff",
    filter: "drop-shadow(0 1px 1px #e1e5e9)"
  };

  return (
    <div className="container">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "8px"
        }}
      >
        <div style={{ position: "relative", display: "inline-block" }}>
          <span
            style={infoIconStyle}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            tabIndex={0}
            aria-label="CSV Info"
          >
            ℹ️
            <span
              style={{
                ...tooltipStyle,
                display: showTooltip ? "block" : "none"
              }}
              className="csv-tooltip"
            >
              Your CSV should have columns: <b>name, amount, cheque_no</b> (see example below)
              <div style={{ margin: "10px 0 0 0" }}>
                <img src="/bulk.png" alt="CSV Example" style={{ width: "100%", maxWidth: "260px", borderRadius: "6px", border: "1px solid #e1e5e9" }} />
              </div>
              <span style={arrowStyle}></span>
            </span>
          </span>
        </div>
        <button
          className="cheque-bulkPrint-btn"
          onClick={() => document.getElementById("csvUpload").click()}
        >
          Select CSV For Bulk Print
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button
          className="cheque-Preview-btn"
          onClick={handleDirectPreview}
          disabled={bulkData.length === 0}
        >
          Preview Bulk Cheques
        </button>
      </div>

      <div></div>

      <div
        className="col-md-12 d-flex justify-content-center align-items-center"
        // style={{ height: "100vh" }}
      >
        {/* Wrapper for Button and Form in a Single Column */}
        <div className="col-md-8">
          <div className="row mb-4 ">
            <div className="col-12">
              <input
                type="file"
                accept=".csv"
                onChange={handleCSVUpload}
                style={{ display: "none" }}
                id="csvUpload"
              />

              {csvError && <div className="text-danger mt-2">{csvError}</div>}
              {bulkData.length > 0 && (
                <div className="mt-2 text-success">
                  {bulkData.length} records loaded successfully
                </div>
              )}
            </div>
          </div>

          <div className="row">
            {/* Form in the second row */}
            <div className="col-12 d-flex justify-content-center">
              
              <form
                className="cheque-form"
                style={{
                  width: "100%",
                  maxWidth: "700px",
                  padding: "40px",
                  background: "#ffffff",
                  border: "1px solid #e1e5e9",
                  borderRadius: "16px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                  position: "relative",
                }}
              >
                <div style={{ marginBottom: "32px", textAlign: "center" }}>
                  <h3 style={{ 
                     
                    fontWeight: "700", 
                    fontSize: "28px",
                    color: "#2c3e50",
                    margin: "0 0 8px 0"
                  }}>
                    Cheque Form
                  </h3>
                  <p style={{ 
                    color: "#7f8c8d", 
                    fontSize: "14px", 
                    margin: "0",
                    
                  }}>
                    Fill in the details below to generate your cheque
                  </p>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginBottom: "32px" }}>
                  {/* Name Field */}
                  <div style={{ position: "relative" }}>
                    <label
                      htmlFor="name"
                  style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "8px",
                        
                      }}
                  >
                      Payee Name
                    </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                      placeholder="Enter payee name"
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "16px",
                        border: errors.name ? "2px solid #e74c3c" : "2px solid #e1e5e9",
                        borderRadius: "8px",
                        outline: "none",
                        background: "#fafbfc",
                        transition: "all 0.2s ease",
                        
                        boxSizing: "border-box"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3498db";
                        e.target.style.background = "#ffffff";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = errors.name ? "#e74c3c" : "#e1e5e9";
                        e.target.style.background = "#fafbfc";
                      }}
                  />
                  {errors.name && (
                      <span style={{ 
                        color: "#e74c3c", 
                        fontSize: "12px", 
                        marginTop: "4px",
                        display: "block",
                        
                      }}>
                        {errors.name}
                      </span>
                  )}
                </div>

                  {/* Date Field */}
                  <div style={{ position: "relative" }}>
                    <label
                      htmlFor="date"
                  style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "8px",
                        
                  }}
                >
                      Cheque Date
                    </label>
                    <div style={{
                      border: errors.date ? "2px solid #e74c3c" : "2px solid #e1e5e9",
                      borderRadius: "8px",
                      // background: "#fafbfc",
                      // transition: "all 0.2s ease",
                      // display: "flex",
                      // alignItems: "center",
                      width: "100%",
                      height: "55px"

}}>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      border: "none",
                      background: "transparent",
                      padding: "14px 16px",
                      fontSize: "16px",
                      outline: "none",
                      
                      height: "100%",
                      boxSizing: "border-box",
                      flex: "1",
                      minWidth: "0"
                    }}
                     />
                    </div>
                  {errors.date && (
                      <span style={{ 
                        color: "#e74c3c", 
                        fontSize: "12px", 
                        marginTop: "4px",
                        display: "block",
                        
                      }}>
                        {errors.date}
                      </span>
                  )}
                </div>

                  {/* Amount Field */}
                  <div style={{ position: "relative" }}>
                    <label
                      htmlFor="amount"
                  style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "8px",
                        
                      }}
                  >
                    Amount
                    </label>
                    <div style={{ position: "relative" }}>
                  <input
                    type="number"
                    id="amount"
                    name="amount"
                    value={formData.amount}
                    onChange={handleChange}
                    placeholder="Enter amount"
                    step="0.01"
                    min="0"
                    inputMode="decimal"
                    onKeyPress={(e) => {
                      if (!/[0-9.]$/.test(e.key) || (e.key === '.' && e.target.value.includes('.'))) {
                        e.preventDefault();
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "14px 16px 14px 16px",
                      fontSize: "16px",
                      border: errors.amount ? "2px solid #e74c3c" : "2px solid #e1e5e9",
                      borderRadius: "8px",
                      outline: "none",
                      background: "#fafbfc",
                      transition: "all 0.2s ease",
                      
                      boxSizing: "border-box"
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#3498db";
                      e.target.style.background = "#ffffff";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = errors.amount ? "#e74c3c" : "#e1e5e9";
                      e.target.style.background = "#fafbfc";
                    }}
                  />
                    </div>
                  {errors.amount && (
                      <span style={{ 
                        color: "#e74c3c", 
                        fontSize: "12px", 
                        marginTop: "4px",
                        display: "block",
                        
                      }}>
                      {errors.amount}
                    </span>
                  )}
                </div>

                  {/* Cheque Number Field */}
                  <div style={{ position: "relative" }}>
                    <label
                      htmlFor="chequeNumber"
                  style={{
                        display: "block",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#2c3e50",
                        marginBottom: "8px",
                        
                      }}
                  >
                    Cheque Number
                    </label>
                  <input
                    type="text"
                    id="chequeNumber"
                    name="chequeNumber"
                    value={formData.chequeNumber}
                    onChange={handleChange}
                    placeholder="Enter cheque number"
                    maxLength={20}
                      style={{
                        width: "100%",
                        padding: "14px 16px",
                        fontSize: "16px",
                        border: errors.chequeNumber ? "2px solid #e74c3c" : "2px solid #e1e5e9",
                        borderRadius: "8px",
                        outline: "none",
                        background: "#fafbfc",
                        transition: "all 0.2s ease",
                        
                        boxSizing: "border-box"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3498db";
                        e.target.style.background = "#ffffff";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = errors.chequeNumber ? "#e74c3c" : "#e1e5e9";
                        e.target.style.background = "#fafbfc";
                      }}
                  />
                  {errors.chequeNumber && (
                      <span style={{ 
                        color: "#e74c3c", 
                        fontSize: "12px", 
                        marginTop: "4px",
                        display: "block",
                        
                      }}>
                      {errors.chequeNumber}
                    </span>
                  )}
                  </div>
                </div>

                <div style={{ textAlign: "center" }}>
                <button
                  type="button"
                  onClick={handleSave}
                    style={{
                      padding: "16px 32px",
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "#ffffff",
                      backgroundColor: "#4a5546",
                      border: "none",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      
                      boxShadow: "0 4px 12px rgba(74, 85, 70, 0.2)",
                      minWidth: "160px"
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#3d4a3a";
                      e.target.style.transform = "translateY(-1px)";
                      e.target.style.boxShadow = "0 6px 16px rgba(74, 85, 70, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#4a5546";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 12px rgba(74, 85, 70, 0.2)";
                    }}
                >
                    Preview Cheque
                </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChequeForm;
